function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetStartedSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 19 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.102,9.24c-0,-2.501 0.851,-4.928 2.414,-6.881c0.735,-0.919 2.132,-0.919 2.867,-0c1.563,1.953 2.414,4.38 2.414,6.881l0,2.657c0,1.097 0,1.645 -0.217,2.062c-0.182,0.351 -0.468,0.637 -0.819,0.82c-0.418,0.216 -0.966,0.216 -2.062,0.216l-1.499,0.001c-1.097,-0 -1.645,-0 -2.062,-0.217c-0.351,-0.183 -0.637,-0.469 -0.82,-0.82c-0.216,-0.417 -0.216,-0.965 -0.216,-2.062l-0,-2.657Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.91,6.338c0,0.531 -0.431,0.962 -0.962,0.962c-0.531,-0 -0.962,-0.431 -0.962,-0.962c0,-0.531 0.431,-0.962 0.962,-0.962c0.531,0 0.962,0.431 0.962,0.962Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.796,7.781l0.822,1.232c1.755,2.634 2.633,3.95 2.089,4.966c-0.543,1.017 -2.126,1.017 -5.291,1.017l-2.935,-0c-3.165,-0 -4.748,-0 -5.291,-1.017c-0.544,-1.016 0.334,-2.332 2.089,-4.966l0.822,-1.232",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.948,17.881l0,1.924m2.886,-1.924l0,0.962m-5.771,-0.962l-0,0.962",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "1.5px",
      strokeLinecap: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStartedSelected);
export default __webpack_public_path__ + "static/media/get_started_selected.d93cd442c056e8938ababe3e591d536a.svg";
export { ForwardRef as ReactComponent };